module.exports = __webpack_public_path__ + "Server-Default.Ftp.121a3b77d4b07e2aeae38594f7cb37e4.hashedasset.svg";